<p-drawer
    [(visible)]="visible"
    [closable]="true"
    [modal]="true"
    appendTo="body"
    [dismissible]="false"
    styleClass="h-[90vh]! email"
    [position]="'bottom'"
    #drawer>
    <ng-template #header>
        <section class="flex! w-full justify-between items-center">
            <div class="flex! items-center gap-3">
                @if (mailluneConfig()) {
                @if (showDynamicPlaceholders()) {
                <button pButton severity="secondary" (click)="showPlaceholders.emit()">{{ 'DYNAMIC_PLACEHOLDERS' | translate }}</button>
                }
                } @else {
                <button pButton severity="secondary" (click)="showPlaceholders.emit()">{{ 'PLACEHOLDERS' | translate }}</button>
                }
                @if (mailluneConfig()) {
                <button pButton severity="secondary" (click)="openTemplates()">{{ 'TEMPLATES' | translate }}</button>
                <button pButton severity="secondary" (click)="openSaveAsTemplateDialog()">{{ 'SAVE_AS_TEMPLATE' | translate }}</button>
                }
            </div>
            <div class="flex! justify-center items-center gap-3">
                <button pButton severity="danger" [disabled]="saving()" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
                <button pButton severity="success" [loading]="saving()" [disabled]="saving()" (click)="save()">{{ 'SAVE' | translate }}</button>
            </div>
        </section>
    </ng-template>

    <ng-template #content>
        @if (mailluneConfig(); as ml) {
        <maillune-template-editor #mailluneTemplateEditor [config]="ml" (templateSaved)="onTemplateSaved($event)"></maillune-template-editor>
        } @else if (beefreeConfig(); as bee) {
        <beefree-template-editor #beefreeTemplateEditor [config]="bee" (templateSaved)="onTemplateSaved($event)"></beefree-template-editor>
        }
    </ng-template>
</p-drawer>

<p-dialog
    [(visible)]="saveAsTemplateDialogVisible"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    appendTo="body"
    [header]="'SAVE_AS_TEMPLATE' | translate"
    styleClass="w-full max-w-lg!">
    <div class="flex! w-full flex-col gap-6 py-2">
        <p-floatlabel variant="on">
            <input
                type="text"
                fluid
                pInputText
                class="w-full"
                [ngModel]="saveAsTemplateName()"
                (ngModelChange)="saveAsTemplateName.set($event)"
                [autofocus]="true" />
            <label>{{ 'TEMPLATE_NAME' | translate }}</label>
        </p-floatlabel>
    </div>

    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <button pButton severity="secondary" (click)="cancelSaveAsTemplate()">{{ 'CANCEL' | translate }}</button>
            <button
                pButton
                [loading]="savingAsTemplate()"
                [disabled]="!saveAsTemplateName().trim()"
                (click)="confirmSaveAsTemplate()">
                {{ 'SAVE' | translate }}
            </button>
        </div>
    </ng-template>
</p-dialog>
